import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M19.71 15.71L18.88 14.88C18.3172 14.3179 18.0007 13.5554 18 12.76V10C18 8.70178 17.5789 7.43858 16.8 6.4L15.9 5.2C15.6206 4.82741 15.2582 4.525 14.8416 4.31672C14.4251 4.10844 13.9657 4 13.5 4H13V2.5C13 2.36739 12.9473 2.24021 12.8536 2.14645C12.7598 2.05268 12.6326 2 12.5 2H11.5C11.3674 2 11.2402 2.05268 11.1464 2.14645C11.0527 2.24021 11 2.36739 11 2.5V4H10.5C10.0343 4 9.57493 4.10844 9.15836 4.31672C8.74179 4.525 8.37944 4.82741 8.1 5.2L7.2 6.4C6.42107 7.43858 6 8.70178 6 10V12.76C5.9993 13.5554 5.68277 14.3179 5.12 14.88L4.29 15.71C4.10526 15.8963 4.0011 16.1477 4 16.41V17C4 17.2652 4.10536 17.5196 4.29289 17.7071C4.48043 17.8946 4.73478 18 5 18H19C19.2652 18 19.5196 17.8946 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17V16.41C19.9989 16.1477 19.8947 15.8963 19.71 15.71V15.71ZM16 16H8V10C8 9.13452 8.28071 8.29238 8.8 7.6L9.7 6.4C9.79315 6.2758 9.91393 6.175 10.0528 6.10557C10.1916 6.03614 10.3448 6 10.5 6H13.5C13.6552 6 13.8084 6.03614 13.9472 6.10557C14.0861 6.175 14.2069 6.2758 14.3 6.4L15.2 7.6C15.7193 8.29238 16 9.13452 16 10V16ZM10 20H14C14 20.5304 13.7893 21.0391 13.4142 21.4142C13.0391 21.7893 12.5304 22 12 22C11.4696 22 10.9609 21.7893 10.5858 21.4142C10.2107 21.0391 10 20.5304 10 20Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgNotificationsOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgNotificationsOutline;
